/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { 
	selectSelectedOwners, 
	selectSelectedCustomers,
	selectSelectedEditors,
	selectSelectedLineNames,
	selectSelectedSurveyTypes,
} from './selectors';

const {
	clear,

	clearCustomers,
	addCustomer,
	removeCustomer,

	clearOwners,
	addOwner,
	removeOwner,

	clearEditors,
	addEditor,
	removeEditor,

	clearLineNames,
	addLineName,
	removeLineName,

	clearSurveyTypes,
	addSurveyType,
	removeSurveyType,
} = createActions(
	{
		CLEAR: () => ({}),

		CLEAR_CUSTOMERS: () => ({}),
		ADD_CUSTOMER: (customer) => ({ customer }),
		REMOVE_CUSTOMER: (customer) => ({ customer }),

		CLEAR_OWNERS: () => ({}),
		ADD_OWNER: (owner) => ({ owner }),
		REMOVE_OWNER: (owner) => ({ owner }),

		CLEAR_EDITORS: () => ({}),
		ADD_EDITOR: (editedBy) => ({ editedBy }),
		REMOVE_EDITOR: (editedBy) => ({ editedBy }),

		CLEAR_LINE_NAMES: () => ({}),
		ADD_LINE_NAME: (name) => ({ name }),
		REMOVE_LINE_NAME: (name) => ({ name }),

		CLEAR_SURVEY_TYPES: () => ({}),
		ADD_SURVEY_TYPE: (surveyType) => ({ surveyType }),
		REMOVE_SURVEY_TYPE: (surveyType) => ({ surveyType }),
	},
	{ prefix: 'DITLineState.filters' }
);

const thunkToggleCustomer = (customer) => (dispatch, getState) => {
	const selectedCustomers = selectSelectedCustomers(getState());
	if (selectedCustomers[customer]) {
		dispatch(removeCustomer(customer));
	} else {
		dispatch(addCustomer(customer));
	}
}

const thunkToggleOwner = (owner) => (dispatch, getState) => {
	const selectedOwners = selectSelectedOwners(getState());
	if (selectedOwners[owner?.compositeId]) {
		dispatch(removeOwner(owner));
	} else {
		dispatch(addOwner(owner));
	}
}

const thunkToggleEditor = (editedBy) => (dispatch, getState) => {
	const selectedEditors = selectSelectedEditors(getState());
	if (selectedEditors[editedBy?.compositeId]) {
		dispatch(removeEditor(editedBy));
	} else {
		dispatch(addEditor(editedBy));
	}
}

const thunkToggleLineName = (lineName) => (dispatch, getState) => {
	const selectedLineNames = selectSelectedLineNames(getState());
	if (selectedLineNames[lineName]) {
		dispatch(removeLineName(lineName));
	} else {
		dispatch(addLineName(lineName));
	}
}

const thunkToggleSurveyType = (surveyType) => (dispatch, getState) => {
	const selectedSurveyTypes = selectSelectedSurveyTypes(getState());
	if (selectedSurveyTypes[surveyType]) {
		dispatch(removeSurveyType(surveyType));
	} else {
		dispatch(addSurveyType(surveyType));
	}
}

export {
	clear,

	clearCustomers,
	addCustomer,
	removeCustomer,

	clearOwners,
	addOwner,
	removeOwner,

	clearEditors,
	addEditor,
	removeEditor,

	clearLineNames,
	addLineName,
	removeLineName,

	clearSurveyTypes,
	addSurveyType,
	removeSurveyType,

	thunkToggleCustomer,
	thunkToggleOwner,
	thunkToggleEditor,
	thunkToggleLineName,
	thunkToggleSurveyType,
};
